"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _mapTo = require("rxjs/operators/mapTo");

var _requestEntity = _interopRequireDefault(require("../requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("../RequestEpicDescriptor"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("./API"));

var _usageTrackerRedux = require("usage-tracker-redux");

var track = _usageTrackerRedux.usageTrackerActions.track;
var fetchShopifyUrlValidity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.checkStoreName,
  initiatingActionType: _actions.ShopifyConnectionActionTypes.FETCH_URL_VALIDITY,
  requestStatusSelector: _selectors.getShopifyUrlValidityRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestActions: _actions.FetchShopifyUrlValidity
}));

var trackInstall = function trackInstall(action$) {
  return action$.ofType(_actions.ShopifyConnectionActionTypes.FINISH_SHOPIFY_CONNECTION).pipe((0, _mapTo.mapTo)(track('susShopifyInstalled')));
};

var _default = (0, _reduxObservable.combineEpics)(fetchShopifyUrlValidity, trackInstall);

exports.default = _default;
module.exports = exports.default;